import { render, staticRenderFns } from "./AddApartment.vue?vue&type=template&id=5b4750ee&scoped=true&"
import script from "./AddApartment.vue?vue&type=script&lang=js&"
export * from "./AddApartment.vue?vue&type=script&lang=js&"
import style0 from "./AddApartment.vue?vue&type=style&index=0&id=5b4750ee&prod&scoped=true&lang=css&"
import style1 from "./AddApartment.vue?vue&type=style&index=1&id=5b4750ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4750ee",
  null
  
)

export default component.exports